<template>
  <div class="bar">Hello</div>
</template>

<script>
import { bus } from "../../main";
export default {
  name: "AnimatedBar",
  props: ["bar", "observer"],
  mounted() {
    this.observer.observe(this.$el);
    bus.$on(this.$el.id, () => {
      console.log("event received");
      // this.$el.animate(
      //   [
      //     // keyframes
      //     { transform: "translateX(0)" } /*0%*/,
      //     {
      //       transform: "translateX(" + this.calculateWidth(this.bar.val) + ")",
      //     } /*30%*/,
      //     { transform: "translateX(0)" } /*100%*/,
      //   ],
      //   {
      //     duration: 3,
      //   }
      // );
      var width = this.calculateWidth(this.bar.val);
      console.log(this.$el.style.width);
      if (this.$el.style.width == width) {
        console.log("reset width");
        this.$el.style.transition = null;
        this.$el.style.width = "0vw";
        setTimeout(() => {
          this.$el.style.width = width;
          this.$el.style.transition = "1s linear";
        }, 1000);
      } else {
        this.$el.style.width = width;
        this.$el.style.transition = "1s linear";
      }
    });
  },
  methods: {
    calculateWidth(val) {
      return val * 100 + "vw";
    },
  },
};
</script>

<style scoped>
.bar {
  background-color: pink;
  height: 10vh;
  width: 0vw;
  /* transition: 2s linear; */
}

/*
@keyframes reducetime {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
} */
</style>
